import { emptyArr } from 'util/arrays'

import selectCurrentSearchTerm from './selectCurrentSearchTerm'

export default function selectCurrentSearchTerms(state) {
  const term = selectCurrentSearchTerm(state)
  return (term && term.split(' ')) || emptyArr
}
